"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HomepageMarquee;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _homepageSplitMarquee = _interopRequireDefault(require("./homepage-split-marquee"));
var _homepageFullMarquee = _interopRequireDefault(require("./homepage-full-marquee"));
var _panel = require("./panel");
/**
 * Render HomepageMarquee
 * @module HomepageMarquee
 * @deprecated This component is deprecated. Please use HPDualMarquee instead.
 *
 * @param {Object} props React props for Homepage Marquee
 * @param {string} props.marqueeLayout Marquee layout
 * @param {object} props.primaryPanel Marquee's Primary Panel
 * @param {object} props.secondaryPanel Marquee's Secondary Panel (optional)
 * @param {boolean} props.reverseMobileLayout Reverses marquee layout on mobile and tablet
 * @returns {React.ReactElement} Homepage Split/Full Marquee based on layout
 * @public
 */
function HomepageMarquee({
  marqueeLayout = 'primary-secondary',
  primaryPanel,
  secondaryPanel,
  reverseMobileLayout,
  partial = ''
}) {
  switch (marqueeLayout) {
    case 'primary-secondary':
    case 'secondary-primary':
      return /*#__PURE__*/_react.default.createElement(_homepageSplitMarquee.default, {
        marqueeLayout: marqueeLayout,
        primaryPanel: primaryPanel,
        secondaryPanel: secondaryPanel,
        reverseMobileLayout: reverseMobileLayout,
        partial: partial
      });
    case 'full':
      return /*#__PURE__*/_react.default.createElement(_homepageFullMarquee.default, {
        primaryPanel: primaryPanel,
        partial: partial
      });
    default:
      return null;
  }
}
HomepageMarquee.propTypes = {
  marqueeLayout: _propTypes.default.oneOf(['primary-secondary', 'secondary-primary', 'full']).isRequired,
  primaryPanel: _propTypes.default.shape({
    ..._panel.PrimaryPanel.propTypes
  }).isRequired,
  secondaryPanel: _propTypes.default.shape({
    ..._panel.SecondaryPanel.propTypes
  }),
  reverseMobileLayout: _propTypes.default.bool,
  partial: _propTypes.default.string
};